'use restrict';

var reportInfoReqCtrl = function ($scope, railApi) {
 
    $scope.total = 0;
    $scope.results = {};
    $scope.hgForm = null;
    $scope.myLength = null;
    $scope.infoReqActivityData = [];

    $scope.getInfoReqActivityReport = function(hgForm, railApiName){
        railApi.get('approval_emails/get_info_req_activty_report', hgForm).promise.then(function(data){
            $scope.infoReqActivityData = data
            $scope.myLength = data.length
        })
    }

    $scope.formatAnswer = function (answer) {
        if (answer == "{NULL}"){
            answer = "N/A"
        }else{
            answer = answer.replaceAll('"', '');
            answer = answer.replaceAll('{', '');
            answer = answer.replaceAll('}', '');
            answer = answer.replaceAll(',', ',\n');
            answer = answer.replaceAll(/[\[\]']+/g,'')
            answer = answer.split(', ').join('\n');
        }
    
        return answer
     };

    $scope.sortResultsBy = function(selection) {
        $scope.toggle = !$scope.toggle
        if (selection == 'author_name') {
            if ($scope.toggle){
                $scope.infoReqActivityData = $scope.infoReqActivityData.sort(function(a, b){
                    if (a.author_name < b.author_name) {return -1};
                    if (a.author_name > b.author_name) {return 1};
                    return 0;  
                    })
            }else{
                $scope.infoReqActivityData = $scope.infoReqActivityData.reverse(function(a, b){
                    if (a.author_name < b.author_name) {return -1};
                    if (a.author_name > b.author_name) {return 1};
                    return 0;  
                    })
            }
        }
        if (selection == 'receiver') {
            if ($scope.toggle){
                $scope.infoReqActivityData = $scope.infoReqActivityData.sort(function(a, b){
                    if (a.receiver < b.receiver) {return -1};
                    if (a.receiver > b.receiver) {return 1};
                    return 0;  
                    })
            }else{
                $scope.infoReqActivityData = $scope.infoReqActivityData.reverse(function(a, b){
                    if (a.receiver < b.receiver) {return -1};
                    if (a.receiver > b.receiver) {return 1};
                    return 0;  
                    })
            }
        }
    }
    //  $scope.calculateTotal = function(result){
    //      var myTotal = 0;         
    //      for(var i = 0; i < result.length; i++){
    //          var logsNum = result[i][1];
    //          myTotal = myTotal + logsNum;
    //      }
 
    //      $scope.total = myTotal;
    //  };
 
    // $scope.getUserAccessLogsReportData = function(hgForm, railApiName) {

    //   railApi.get('user_access_logs/').promise.then(function(myData) {
    //       $scope.allLogs = myData;

    //       $scope.userAccessLogs = $scope.allLogs.filter(function(item) {
    //         return item.date.toISOString().split('T')[0] >= hgForm.start_date.toISOString().split('T')[0] && item.date.toISOString().split('T')[0] <= hgForm.end_date.toISOString().split('T')[0];
    //       });
    //       $scope.userAccessLogsNumber = $scope.userAccessLogs.length;
    //     });
    //   }

    // $scope.int_to_ip = function(ipInt) { //convert int ipaddress to 0.0.0.0 format
    //     return ( (ipInt>>>24) +'.' + (ipInt>>16 & 255) +'.' + (ipInt>>8 & 255) +'.' + (ipInt & 255) );
    // }
};
 
module.exports = reportInfoReqCtrl;